import React from 'react';
import { Sidebar } from 'primereact/sidebar';
import './DrawerAtom.scss';

export interface DrawerAtomProps {
  visible: boolean;
  onHide: () => void;
  position?: 'left' | 'right' | 'top' | 'bottom';
  width?: string;
  height?: string;
  modal?: boolean;
  showCloseIcon?: boolean;
  header?: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  children: React.ReactNode;
}

const DrawerAtom: React.FC<DrawerAtomProps> = ({
  visible,
  onHide,
  position = 'right',
  width,
  height,
  modal = false,
  showCloseIcon = true,
  header,
  className = '',
  style,
  children,
}) => {
  const sidebarStyle: React.CSSProperties = { ...style };
  if (width && (position === 'left' || position === 'right')) {
    sidebarStyle.width = width;
  }
  if (height && (position === 'top' || position === 'bottom')) {
    sidebarStyle.height = height;
  }

  return (
    <Sidebar
      visible={visible}
      onHide={onHide}
      position={position}
      dismissable={!modal}
      showCloseIcon={showCloseIcon}
      header={header}
      className={`drawer-atom ${className}`.trim()}
      style={sidebarStyle}
      modal
    >
      {children}
    </Sidebar>
  );
};

DrawerAtom.displayName = 'DrawerAtom';

export default DrawerAtom;
